import mitt, { Emitter } from 'mitt';

type Events = {
  unit: string;
  sidebar: string;
  projectsidebar: string;
  tpisidebar: string;
};

export const emitter: Emitter<Events> = mitt<Events>();
